<template>
    <div class="nota d-flex align-items-center flex-wrap box-estrelas">
        <span class="txt-p txt-size-16 txt-w-7 txt-grey-4">{{nota}}</span>
        <div class="estrelas mx-2 d-flex">
            <i :class="'fas fa-star '+(nota >= notas?'txt-cores-1':'txt-grey-3') " v-for="notas in 5" :key="notas"></i>
            <!--<i class="fas fa-star-half-alt"></i>-->
        </div>
        <span class="txt-p txt-size-9 txt-w-4 txt-grey-4 " v-if="qtdAvaliacoes != null">
            {{qtdAvaliacoes}} avaliações
        </span>
        <span v-else class="txt-p txt-size-9 txt-w-4 txt-grey-4 ">
            Esta é a nota média que você deu para este curso até o momento.
        </span>
    </div>
</template>

<script>

    export default {
        name: 'Estrelas',
        components: {},
        props: {
            nota: {
                type: Number,

            },
            qtdAvaliacoes: {
                type: Number,

            },

        }, 
        data: function () {
            return {
                
            }
        },
        methods: {



        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @media (max-width: 767.98px) {
        .box-estrelas{
            /*justify-content: center;*/
        }
    } 
</style>

